import Model  from '@/util/models';

export default class Dashboard extends Model { 
    backend = '/master/dashboard/'; 
     
    miniStatistic(params = {}){
      return this.api.get(this.backend + 'mini-statistic', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    }
    
    chartStatistic(params = {}){
      return this.api.get(this.backend + 'chart-statistic', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    } 
     
    tingkats(params = {}){
      return this.api.get(this.backend + 'tingkats', params).then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }
    
    status(){
      return this.api.get(this.backend + 'status').then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }        
        
}

